export function setupFaqs( selector = '.faq__list' ) {
	const lists = document.querySelectorAll( selector );
	if ( !lists[0] ) {
		return;
	}

	for ( let i = 0; i < lists.length; i++ ) {
		setupFaq( lists[i] );
	}

	function setupFaq( list ) {
		const questions = list.querySelectorAll( '.faq__question' );

		for ( let i = 0; i < questions.length; i++ ) {
			const question = questions[i];
			const item = question.closest( '.faq__item' );
			if ( !item ) {
				continue;
			}

			syncState( question, item );
			question.addEventListener( 'click', handleToggle( list, question, item ) );
		}
	}

	function handleToggle( list, question, item ) {
		return () => {
			const will_open = !item.classList.contains( 'faq__item--open' );

			// Only one answer open at a time — collapse the rest of this list first.
			closeAll( list );

			if ( will_open ) {
				item.classList.add( 'faq__item--open' );
				syncState( question, item );
			}
		};
	}

	function closeAll( list ) {
		const open_items = list.querySelectorAll( '.faq__item--open' );

		for ( let i = 0; i < open_items.length; i++ ) {
			const open_item = open_items[i];
			const open_question = open_item.querySelector( '.faq__question' );

			open_item.classList.remove( 'faq__item--open' );
			if ( open_question ) {
				syncState( open_question, open_item );
			}
		}
	}

	function syncState( question, item ) {
		const is_open = item.classList.contains( 'faq__item--open' );
		question.setAttribute( 'aria-expanded', is_open ? 'true' : 'false' );
	}
}
